<script setup lang="ts">
import AppNotification from './components/AppNotification.vue';
import EventTriggeredCompleteCheckoutDialog from './components/EventTriggeredCompleteCheckoutDialog.vue';
import { useJunoAnalytics } from '@/composables/useJunoAnalytics';

useJunoAnalytics();
</script>

<template>
  <v-app>
    <v-main>
      <div id="app-notifications">
        <app-notification
          position="bottom right"
          class="mb-2"
          group="bottom-notifications"
          :max="5"></app-notification>
        <app-notification
          position="top right"
          class="mt-2 mr-2"
          group="top-notifications"
          :max="5"></app-notification>
      </div>

      <event-triggered-complete-checkout-dialog />

      <RouterView />
    </v-main>
  </v-app>
</template>

<style lang="scss">
@use '@/styles/main.scss';

#app-notifications {
  .vue-notification-group {
    min-width: 250px !important;
    width: auto !important;
    max-width: 500px;
    right: 1rem !important;
    z-index: 10000000000000;
  }

  &.is-mobile {
    .vue-notification-group {
      width: 90% !important;
      left: 5% !important;
    }
  }

  .vue-notification-wrapper {
    &:not(:first-child) {
      margin-top: 0.5rem;
    }
  }

  .app-notification {
    border-radius: 5px;
    position: relative;
    padding: 0.5rem 1rem;

    i.type-icon {
      color: $white;
    }

    &.success {
      background-color: $white !important;
      border: 1px solid getVuetifyColor(success) !important;
      border-left: 40px solid getVuetifyColor(success) !important;
      color: $black;
    }

    &.error {
      background-color: $white !important;
      border: 1px solid getVuetifyColor(error) !important;
      border-left: 40px solid getVuetifyColor(error) !important;
      color: $black;
    }

    &.warning,
    &.warn {
      background-color: $white !important;
      border: 1px solid getVuetifyColor(warning) !important;
      border-left: 40px solid getVuetifyColor(warning) !important;
      color: $black;
    }

    &.info {
      background-color: $white !important;
      border: 1px solid $color-accent-60 !important;
      border-left: 40px solid $color-accent-60 !important;
      color: $black;
    }

    .title {
      font-size: 1rem !important;
      margin-bottom: 0;
      line-height: 1.25rem;
    }

    i.type-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      margin-left: -35px;
      font-size: 2rem;
      z-index: 15;
    }

    .close {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      padding: 0 0.5rem;

      i {
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 600px) {
  #app-notifications {
    .vue-notification-group {
      max-width: calc(100% - 2rem);
    }
  }
}
</style>
